<table>
    <tr>
      <td style="text-align: center">
        <b>Conditions of Permit</b><br />
        <b>Hydrant Usage Permit</b><br /><br />
      </td>
    </tr>
    <tr>
      <td>
        <b>Cartage of Hydrant Water</b> <br />
        1. The permit holder is responsible for ensuring that it meets its legal obligations
        under the Victorian Food Act 1984 and delivers water to its customers that
        are safe and suitable for its intended use. For more information, see the
        Water Unit, Health Protection section of the Department of Human Services website <a
          href="http://www.health.vic.gov.au/water" target="_blank">www.health.vic.gov.au/water</a>.
        Without limiting this general obligation, a tanker used to cart drinking
        (potable) water for human consumption, food preparation or ice making,
        must not be used to cart reclaimed water, toxic or hazardous chemicals,
        non-food liquids, and human or animal wastes.
        <br />
        <br />
        2. Water drawn from South East Water hydrants under this permit must only be used
        within South East Water's operating area.
        <br /><br />
        <b>Records of Usage</b><br />
        3. The permit holder must ensure the amount of water withdrawn every month is forwarded
        to South East Water by either:<br />
        <table>
          <tr>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <li>Using the Hydrotrak system </li>
              <li>Access to Hydrant Permit Scheme by web application via SEW internet site <a
                  href="http://www.southeastwater.com.au" target="_blank">www.southeastwater.com.au</a>,
                "Business" page and record the number of loads withdrawn every month from the log sheets.</li>
              <li>Forward the completed log sheets every month to South East Water. </li>
            </td>
          </tr>
        </table>
        <br /><br />
        <b>Backflow Prevention & Training</b><br />
        4. The permit holder must ensure that at all times during the term of this permit the vehicles authorised
        under the permit are each fitted with a backflow prevention device or air disconnected inlet pipe (air gap).
        <br />
        The testing results/certification of any approved backflow prevention device must be supplied to South East
        Water
        within three (3) months of applying for a hydrant permit. <br />
        The backflow device is to then be tested annually by an authorised plumber and a copy of the certificate
        provided to
        South East Water.
        <br /><br />
        5. The permit holder must ensure that any person involved in accessing and drawing water from a hydrant
        under
        the authority of this permit:<br />
        <table>
          <tr>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <li>Has read and understood South East Water procedure for operating hydrants prior to accessing any
                South East Water hydrants; and </li>
              <li>Is aware of the terms and conditions applying to this Permit.</li>
              <li>Utilise our webapp - <a
                  href="https://ws.iota.net.au/HydroTrakHydrants" target="_blank">https://ws.iota.net.au/HydroTrakHydrants</a>, to ensure
                that water is being drawn from an authorised hydrant.</li>
              <li>Contact South East Water on <b>132 812</b> if unsure if hydrant is approved prior to withdrawing
                water.</li>
            </td>
          </tr>
        </table>
        <br /><br />

        6. If at any time the permit holder becomes aware of an incident which may involve a contamination of the
        water supply, the Permit
        holder must immediately contact South East Water on <b>132 812</b>. <br /><br />

        <b>Hydrants</b><br />
        7. Hydrants located on 150mm to 225mm water mains can be accessed by hydrant permit holders.
        Hydrants that are located on water mains that are 100mm or smaller are unauthorised and not to be accessed
        by hydrant permit holders due to the risk of causing dirty water to our customers. Larger diameter mains
        (300mm and greater) pose a different risk to our supply due to the impacts of possible damage. <br />
        <table>
          <tr>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <li>Utilise our webapp - <a target="_blank"
                  href="https://ws.iota.net.au/HydroTrakHydrants">https://ws.iota.net.au/HydroTrakHydrants</a>, to ensure
                that water is being drawn from an authorised hydrant</li>
              <li>Contact South East Water on 132 812 if there is any damage to a hydrant.</li>
            </td>
          </tr>
        </table>
        <br /><br />
        <b>General Conditions</b><br />
        8. The permit holder agrees to indemnify South East Water for: <br />
        <table>
          <tr>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <li>Any breach of the permit holder's obligation under this Agreement;</li>
              <li>Any damage caused to any hydrants or other property;</li>
              <li>Any disruption to the water supply the permit holder, its employees or agents may cause; or</li>
              <li>Any claims concerning property damage, pecuniary loss, injury or death to third parties resulting
                from any act or omission by the permit holder, its employees or agents.</li>
            </td>
          </tr>
        </table>
        <br /><br />
        9. Hydrants can only be accessed for the purpose of filling a mobile water tank. All vehicles authorised
        under this permit must have a current "Hydrant Permit Holder" sticker issued by South East Water displayed
        at all times.
        This sticker must be removed once the permit has expired.
        <br /><br />
        10. Only those vehicles registered on this permit are authorised to access and draw water from South East
        Water hydrants. If there are additional vehicles that the applicant wishes to access hydrants with, then a
        new permit application must be completed.
        <br /><br />
        11. The permit holder must provide South East Water with access to any of the Permit holder's information or
        records reasonably required by South East Water in order to allow audit compliance with the terms and
        conditions of this Permit.
        <br /><br />
        12. The permit holder must do all things necessary to ensure that there is no wastage of water when
        operating the hydrant.
        <br /><br />
        13. The permit holder must ensure the appropriate use of a hydrant to avoid causing sudden changes to flow
        in the water main – this is achieved by ensuring the hydrants are turned on and off at a slow pace and
        filled at a reasonable flow rate.
        <br /><br />
        14. The permit is granted for a period of 12 months from the date of issue and is granted only in respect to
        the vehicle register and described in the schedule.
        <br /><br />
        15. The Hydrant Permit Holder must notify South East Water to remove the Hydrotrak device from the vehicle
        on termination of the Hydrant Permit. South East Water will arrange the removal of the device within 10
        working days of notification provided the vehicle is within South East Water Operational area at no cost to
        the Permit Holder.
        <br /><br />
        16. The Hydrant Permit Holder must return the Hydrotrak device to South East Water on termination of the
        Permit if the vehicle is not within South East Water operational area at the Hydrant Permit Holders cost.
        <br /><br />
        17. The Hydrant Permit Holder will incur a $1,000 penalty if the Hydrotrak device is not returned to South
        East Water within 20 working days on termination of the Hydrant Permit. The Hydrant Permit Holder will also
        incur South East Water costs to recover the Hydrotrak device.
        <br /><br />
        18. The Hydrant Permit Holder must notify South East Water if the vehicle attached to the Hydrant Permit is
        sold or any details relating to the capacity of the water tank change. Failure to return the hydrotrak unit
        will incur a $1000.00 penalty.
        <br /><br />
        19. The Hydrant Permit Holder is responsible for maintaining the Hydrotrak device in working order. Any
        damage or missing device will be the responsibility of the Hydrant Permit Holder and will incur a cost for a
        replacement device ($1000.00). Report any damage or faults to Hydrotrak Administrator on 9552 3114.
        <br /><br />
        20. South East Water will cover the cost of the Hydrotrak device, installation and all the communication
        costs and install the device at an agreed time and location with the Hydrant Permit Holder.
        <br /><br />
        21. The Hydrant Permit Holder MUST ensure the person involved in accessing and drawing water from a hydrant
        under the authority of this permit presses the button on the Hydrotrak Device before withdrawing water from
        the Hydrant.
        <br /><br />
        22. The Permit Holder acknowledges and accepts that they Hydrotrak device is also a GPS tracking device
        which enables South East Water to locate the vehicle to which it is fitted.
        <br /><br />
        23. The Permit Holder MUST ensure that any person using the vehicle to which the Hydrotrak device is fitted
        acknowledges and accepts that the Hydrotrak device is also a GPS tracking device.
        <br /><br />
        24. South East Water will use the Hydrotrak device to calculate the monthly invoice for the amount of water
        withdrawn from Hydrants.
        <br /><br />
        25. The Permit Holder is responsible to for paying the monthly total of water taken using the Hydrotrak
        device. Where the vehicle is rented to a third party, the Permit Holder is still responsible for the water
        usage.
        <br /><br />
        26. Failure to comply with any of the above terms and condition may result in a Penalty Infringement Notice
        being issued and or under section 289 of the Water Act 1989 a substantial penalty or 6 months jail can be
        issued. The Hydrant
        Permit issued to the Permit Holder may also be withdrawn by South East Water.
        <br /><br />
      </td>
    </tr>
  </table>